const CM_PER_INCH = 2.54;
const INCH_PER_FOOT = 12;

/**
 * `convertFeetStringToCm` takes a string formatted as a measurement of feet and
 * inches (eg, `5'11"`), and returns a number representing that height
 * measurement in CM.
 */
export const convertFeetStringToCm = (height = '') => {
  const heightUnits = height?.split("'").map(unit => parseInt(unit.replace(/\D/g, ''), 10));
  const heightInCm = (heightUnits?.[0] * INCH_PER_FOOT + heightUnits?.[1]) * CM_PER_INCH;
  return Math.round(heightInCm * 100) / 100;
};

/**
 * `convertCmToFeetString` takes a number representing a measurement of
 * centimeters, and returns a string representing that measurement in feet and
 * inches (eg, `5'11"`).
 */
export const convertCmToFeetString = (height = 0) => {
  const totalHeightInFeet = height / CM_PER_INCH / INCH_PER_FOOT;
  const feet = Math.floor(totalHeightInFeet);
  const remainingInches = Math.round((totalHeightInFeet - feet) * INCH_PER_FOOT);

  return `${feet}'${`${remainingInches}`.padStart(2, '0')}"`;
};
